import { composeIO } from 'react-compose-io'
import { tabelaErroProcessamentoIO } from './TabelaErroProcessamento.IO'
import { TabelaErroProcessamentoView } from './TabelaErroProcessamento.View'

export const TabelaErroProcessamento = composeIO(TabelaErroProcessamentoView, tabelaErroProcessamentoIO)
